import cn from "classnames";
import ChatFooter from "components/shared/chat/footer";
import Loader from "components/shared/loader";
import { paths } from "helpers/paths";
import { chatContainer } from "helpers/redux";
import { ymEvent } from "helpers/system";
import policy from "policies";
import React, { useEffect, useState } from "react";
import { Link, withRouter } from "react-router-dom";
import { addChatToFavorites, getChatInfo, removeChatFromFavorites, sendFile, sendMessage } from "sources/carChats";
import ChatBody from "./chatBody";

function CarChat(props) {
    const [onlyMyMessages, setOnlyMyMessages] = useState(false);
    const [loading, setLoading] = useState(true);
    const [loadingHeader, setLoadingHeader] = useState(false);
    const [info, setInfo] = useState({});

    useEffect(() => {
        const { chatId } = props;
        getChatInfo(chatId).then((info) => {
            setInfo(info);
            setLoading(false);
        });
    }, []);

    const { chatId, profile, token, back, modal, roles } = props;

    const toggleFavorite = (e) => {
        e.stopPropagation();
        if (loadingHeader) {
            return;
        }
        setLoadingHeader(true);
        (info.chat.isFavorite ? removeChatFromFavorites({ chatId }) : addChatToFavorites({ chatId })).then((res) => {
            setLoadingHeader(false);
            if (res) {
                setInfo((prevInfo) => ({
                    ...prevInfo,
                    chat: { ...prevInfo.chat, isFavorite: !prevInfo.chat.isFavorite },
                }));
            }
        });
    };

    const chatProps = {
        chatId,
        info,
        profile,
        token,
        modal: props.modal,
        onlyMyMessages,
        showOnlyMyMessages: true,
        onOnlyMyMessagesChange: setOnlyMyMessages,
    };

    const sendMessageHandle = (data) => sendMessage({ text: data.text, aggregationChatId: data.chatId });
    const sendFileHandle = (data) => {
        data.body.append("aggregationChatId", chatId);
        data.body.delete("chatId");
        sendFile(data);
    };

    const bidsInfo = () => {
        if (!info?.bids?.length) {
            return null;
        }
        const [firstBid, ...bids] = info.bids;
        const compoundBidsModal = () => {
            if (bids.length === 0) {
                return null;
            }
            const showModal = () => {
                props.modal({
                    name: "infoModal",
                    windowMod: "wide",
                    title: "Список сборных заявок",
                    body: (
                        <table className="table table-sm">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Заявка</th>
                                    <th>Водитель</th>
                                </tr>
                            </thead>
                            <tbody>
                                {bids.map((item, i) => (
                                    <tr key={item.id}>
                                        <td>{i + 1}</td>
                                        <td>
                                            <Link to={paths.bidShow("bid", item.id)} target="_blank">
                                                {item.id}
                                            </Link>
                                        </td>
                                        <td>
                                            <Link to={paths.driversShow(item.driverId)} target="_blank">
                                                {item.driver?.fullName}
                                            </Link>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ),
                });
            };
            return (
                <span className="link text-underline pl-4" onClick={showModal}>
                    Просмотреть сборные заявки
                </span>
            );
        };
        return (
            <div className="small">
                <div>
                    Заявка:&nbsp;
                    <Link to={paths.bidShow("bid", firstBid.id)} target="_blank">
                        {firstBid.id}
                    </Link>
                    {compoundBidsModal()}
                </div>
                {firstBid.driverId && (
                    <div>
                        Водитель:&nbsp;
                        <Link to={paths.driversShow(firstBid.driverId)} target="_blank">
                            {firstBid.driver?.fullName}
                        </Link>
                    </div>
                )}
            </div>
        );
    };

    return loading ? (
        <Loader prefix="absolute-center" />
    ) : (
        <div className="page-book__show chat-layout">
            <div className="chat-layout__head pl-5">
                <div className={cn("chat-layout__head-name mb-1", { "loading loading--small": loadingHeader })}>
                    <div className="d-flex w-100">
                        <div className="flex-grow-1">
                            <i
                                className={cn("chat-layout__favorite-icon icon-uEABA-star-solid", {
                                    "chat-layout__favorite-icon--selected": info.chat.isFavorite,
                                })}
                                onClick={toggleFavorite}
                            />
                            {info.chat.description}
                        </div>
                        <div>
                            <div>
                                <Link
                                    to={`${paths.profileAccount}?tab=notification-settings`}
                                    className="font-size-12 nowrap-text"
                                    onClick={() => ymEvent("NotificationsSettingsClicked")}
                                >
                                    <i className="icon-uEA0C-gear inline-icon pr-1" />
                                    Настройки уведомлений
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                {bidsInfo()}
                <div className="chat-layout__close close close--md" onClick={back} />
            </div>
            <div className="chat-layout__body">
                <ChatBody {...chatProps}>
                    {!policy("user", { user: { roles } }).isOnlyViewer() && (
                        <ChatFooter
                            chatId={chatId}
                            modal={modal}
                            info={info}
                            theme={props.theme}
                            sendMessage={sendMessageHandle}
                            sendFile={sendFileHandle}
                        />
                    )}
                </ChatBody>
            </div>
        </div>
    );
}

export default withRouter(chatContainer(CarChat));
